<template>
  <div class="wrapper">
    <v-form ref="form" v-model="form.valid">
      <v-row>
        <v-col>
          <v-text-field
            v-model="loginData.username"
            label="Usuario"
            type="text"
            outlined
            required
            autofocus
            hide-details
            :rules="[form.rules.required]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            v-model="loginData.password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            label="Contraseña"
            :type="show ? 'text' : 'password'"
            outlined
            required
            :rules="[form.rules.required]"
            counter
            @click:append="show = !show"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-select
            v-model="loginData.mode"
            :items="loginOptions"
            label="Ingresar como"
            outlined
            hide-details
            :rules="[form.rules.required]"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <vue-recaptcha
            sitekey="6LfLMrUZAAAAADC7Oivy3Lcqx384qActTuEjFPYw"
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            :loadRecaptchaScript="true"
            language="es"
          ></vue-recaptcha>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn
            width="100%"
            color="primary"
            @click="login"
            :disabled="!form.valid || !recaptchaToken"
            >Ingresar</v-btn
          >
        </v-col>
      </v-row>

      <v-row>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <small>Recuperar contraseña</small>
            </v-card-title>
            <v-card-text>
              <span
                >Introduce tu usuario y recibirás un email con las instrucciones
                para restaurar tu contraseña</span
              >
              <v-form v-model="form.valid1">
                <v-text-field
                  type="text"
                  placeholder="Usuario"
                  :rules="[form.rules.required]"
                  v-model="recoveryData.username"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="red darken-1" text error @click="dialog = false"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" text :disabled="!form.valid1" @click="recuperarpassword"
                >Enviar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn width="100%" color="blue" dark @click="dialog = true"
            >Olvide mi contraseña</v-btn
          >
        </v-col>
      </v-row>
    </v-form>

    <img class="logo-vt" src="@/assets/Recurso 7.png" alt />
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { oAuth } from "../classes/Auth";
import { getTokenPayload } from "../globals";
import { apiv1 } from "../libs/apiv1";
import VueRecaptcha from "vue-recaptcha";

export default Vue.extend({
  name: "Login",
  components: {
    VueRecaptcha,
  },
  data: () => ({
    dialog: false,
    show: false,

    loginData: {
      username: "",
      password: "",
      mode: "CLIENTE",
    },

    recoveryData: {
      username: "",
      mode: "CLIENTE",
    },

    form: {
      valid: true,
      valid1: true,
      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
      },
    },

    loginOptions: ["CLIENTE", "VERTEBRA"],

    captchaKey: process.env.VUE_APP_CAPTCHA_SITEKEY,
    recaptchaToken: "",
  }),

  methods: {
    onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
    },

    login() {
      const reqBody = {
        ...this.loginData,
        recaptchaToken: this.recaptchaToken,
      };
      oAuth
        .login(reqBody)
        .then((res) => {
          const { token } = res.headers;
          const { user, project } = res.data;
          const payload = getTokenPayload(token);
          oAuth.setUser(user);
          oAuth.setToken(token);
          oAuth.setProject(project);
          if (payload.vertebra) {
            this.$router.push("/choose-project");
          } else {
            this.$router.push("/smartchronos/dashboard2");
          }
        })
        .catch((err) => {
          this.$awn.alert(err.response ? err.response.data : err);
          this.$refs.recaptcha.reset();
          this.recaptchaToken = "";
        });
    },
    async recuperarpassword() {
      try {
        const res = await axios({
          url: `${process.env.VUE_APP_BACKEND}/password-recover`,
          method: "POST",
          data: { username: this.recoveryData.username }
        });
        this.recoveryData.username = null;
        this.$awn.success(res.data.message);
      } catch (error) {
          this.$awn.alert(err.response.data.message);
      } finally{
         this.dialog = false;
      }
    }
  },
});
</script>





<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: url("~@/assets/earth.jpg");
  // background: url('http://www.4kwallpaperhd.com/wp-content/uploads/2018/05/Waterfall-River-photo-wallpaper-4k-3840x2160.jpg')
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: " ";
    background: url("~/smartchronos2.svg");
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    bottom: 20px;
    left: 20px;
    height: 77px;
    width: 333px;
  }

  form {
    background: rgba(#fff, 0.8);
    width: 350px;
    padding: 20px;

    #messages {
      padding: 10px;
      background: #d5ad2b;
      color: #fff;
      position: relative;
      font-size: 0.9em;

      &:after {
        bottom: 100%;
        left: 50%;
        border: 1px solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(213, 173, 43, 0);
        border-bottom-color: #d5ad2b;
        border-width: 10px;
        margin-left: -10px;
      }

      div {
        width: 100%;
      }
    }
  }

  .logo-vt {
    width: 350px;
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 20px;
    background: green;
  }
}

@media screen and (min-width: 400px) {
  .wrapper {
    form {
      position: fixed;
      right: 0;
      top: 0;
      height: 100%;
    }
  }
}
</style>
